import React from "react";

const AccountDeletion = () => {
    return (<div className="screen">
        <h1>Otus Account Deletion</h1>
        <p>To delete your account follow these steps:</p>
        <ol>
            <li>Press the menu button at the top left of the screen</li>
            <li>Press the "Settings" button</li>
            <li>Press the "Account Setting" button</li>
            <li>Press the "Delete Account" button and confirm </li>
        </ol>
        <h3>*Warning!</h3>
        <p>This irrevocable process will delete all your personal data and nothing will be retained.</p>
    </div>)
}

export default AccountDeletion